'use client';

export default function RestaurantsError({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <div className="container py-10 text-center">
      <h2 className="text-xl font-semibold mb-4">Something went wrong</h2>
      <p className="text-gray-500 mb-6">{error.message}</p>
      <button onClick={reset} className="btn btn-primary">
        Try again
      </button>
    </div>
  );
}
